import { MetadataTitle } from "@/components/vault/viewer/stickers/title/MetadataTitle";
import { VaultObjectViewerData } from "@/components/vault/viewer/VaultObjectViewerModal";
import { useScreenStore } from "@/stores/useScreenStore";
import useVaultStore from "@/stores/zustand/vault/useVaultStore";
import { AnimatePresence } from "motion/react";
import React, { RefObject, useEffect } from "react";

interface VaultObjectViewerTitleProps {
  newName: string;
  setNewName: React.Dispatch<React.SetStateAction<string>>;
  newNameInputErrorMessage: string;
  setNewNameInputErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  newTagValueList: string[];
  inputTagValue: string;
  setInputTagValue: React.Dispatch<React.SetStateAction<string>>;
  newTagInputErrorMessage: string;
  handleAddTag: () => void;
  handleRemoveTag: () => void;
  titleRef: RefObject<HTMLDivElement>;
  newNameInputRef: RefObject<HTMLInputElement>;
  tagListRef: RefObject<HTMLDivElement>;
  newTagInputRef: RefObject<HTMLInputElement>;
  vaultObjectViewerData: VaultObjectViewerData | null;
}

export const VaultObjectViewerTitle: React.FC<VaultObjectViewerTitleProps> = ({
  newName,
  setNewName,
  newNameInputErrorMessage,
  newTagValueList,
  inputTagValue,
  setInputTagValue,
  newTagInputErrorMessage,
  setNewNameInputErrorMessage,
  handleAddTag,
  handleRemoveTag,
  titleRef,
  newNameInputRef,
  tagListRef,
  newTagInputRef,
  vaultObjectViewerData,
}) => {
  const isMobileScreen = useScreenStore((state) => state.isMobileScreen);

  const currentPage = useVaultStore((state) => state.currentPage);
  const currentTab = useVaultStore((state) => state.currentTab);

  useEffect(() => {
    if (!newName) return;
    newNameInputRef.current?.focus();
    setNewNameInputErrorMessage("");
  }, [newName]);

  return (
    <div
      ref={titleRef}
      style={{
        bottom: isMobileScreen ? 0 : currentTab === "show-window" ? 120 : 58,
        width: currentPage === "viewer" ? "fit-content" : "100%",
        transition: "all 0.3s ease-in-out",
      }}
      className={
        "select-none flex pointer-events-auto absolute left-0 px-5 py-5 overflow-visible z-20"
      }
    >
      <AnimatePresence mode="wait">
        <MetadataTitle
          newNameInputRef={newNameInputRef}
          newName={newName}
          setNewName={setNewName}
          newNameInputErrorMessage={newNameInputErrorMessage}
          tagListRef={tagListRef}
          newTagValueList={newTagValueList}
          newTagInputRef={newTagInputRef}
          inputTagValue={inputTagValue}
          setInputTagValue={setInputTagValue}
          newTagInputErrorMessage={newTagInputErrorMessage}
          handleAddTag={handleAddTag}
          handleRemoveTag={handleRemoveTag}
          vaultObjectViewerData={vaultObjectViewerData}
        />
      </AnimatePresence>
    </div>
  );
};
